import React, { createContext, useContext, useReducer, ReactNode, Dispatch } from 'react';

interface AdminDataState {
  showInfo: boolean;
}

type AdminDataAction = { type: 'TOGGLE_INFO'; value: boolean };

const initialAdminDataState: AdminDataState = {
  showInfo: true
};

const AdminDataContext = createContext<
  { state: AdminDataState; dispatch: Dispatch<AdminDataAction> } | undefined
>(undefined);

const adminDataReducer = (state: AdminDataState, action: AdminDataAction): AdminDataState => {
  switch (action.type) {
    case 'TOGGLE_INFO':
      return { ...state, showInfo: action.value };
    default:
      return state;
  }
};

interface AdminDataProviderProps {
  children: ReactNode;
}

const AdminDataProvider: React.FC<AdminDataProviderProps> = ({
  children
}: AdminDataProviderProps) => {
  const [state, dispatch] = useReducer(adminDataReducer, initialAdminDataState);
  return (
    <AdminDataContext.Provider value={{ state, dispatch }}>{children}</AdminDataContext.Provider>
  );
};

export const useAdminData = () => {
  const context = useContext(AdminDataContext);
  if (context === undefined) {
    throw new Error('useAdminData must be used within an AdminDataProvider');
  }
  return context;
};

export default AdminDataProvider;
